<template>
  <div
    class="product-badge"
    :class="{
      'type-default': isTypeSale || isTypeCustom,
      'type-clearance': isTypeClearance,
      [size]: size,
    }"
  >
    <div class="badge-text">
      <template v-if="isTypeSale">
        <span>Sale</span>
      </template>
      <template v-else-if="isTypeClearance">
        <span>Last Chance</span>
      </template>
      <template v-else-if="isTypeCustom">
        <span v-if="text">{{ text }}</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBadge',
  props: {
    light: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 48,
    },
    height: {
      type: Number,
      default: 48,
    },
    type: {
      type: String,
      default: 'custom',
      validator(value) {
        return ['sale', 'clearance', 'custom'].includes(value);
      },
    },
    text: {
      type: String,
    },
    textSize: {
      type: String,
    },
    size: {
      type: String,
      validator(value) {
        return ['small'].includes(value);
      },
    },
  },
  computed: {
    isTypeSale() {
      return this.type === 'sale';
    },

    isTypeClearance() {
      return this.type === 'clearance';
    },

    isTypeCustom() {
      return this.type === 'custom';
    },

    widthPx() {
      return `${this.width}px`;
    },

    heightPx() {
      return `${this.height}px`;
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.product-badge {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 48px;
  height: 48px;
  border-radius: var(--circle-border-radius);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  &.small {
    width: 38px;
    height: 38px;
  }

  &.type-default {
    &.small {
      .badge-text {
        font-size: 0.5em;
      }
    }

    background-color: var(--accent-color);

    .badge-text {
      color: var(--white);
      font-size: 0.7em;
    }
  }

  &.type-clearance {
    border: 1px solid var(--accent-color);
    background-color: white;

    &:not(.small) {
      .small-text {
        display: none;
      }
    }

    &.small {
      .default-text {
        display: none;
      }

      .badge-text {
        font-size: 6.5px;
        line-height: 7px;
      }
    }

    .badge-text {
      color: var(--accent-color);
      font-size: 0.5em;
      line-height: 10px;
    }
  }

  .badge-text {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    font-family: var(--font-bold);
    letter-spacing: 1px;
  }
}
</style>
